import * as qf from '../../../misc/qf.js';

export const
  APPEND_EVENTS = "APPEND_EVENTS",
  SET_CURRENT_DATE = "SET_CURRENT_DATE",
  GET_EVENT_LIST = "GET_EVENT_LIST",
  SET_EVENT_LIST = "SET_EVENT_LIST",
  FAILED_EVENT_LIST = "FAILED_EVENT_LIST",
  SET_CURR_EVENT_LIST = "SET_CURR_EVENT_LIST",
  SET_EVENT_DATE = "SET_EVENT_DATE",
  SET_MONTH_SHOWN = "SET_MONTH_SHOWN",
  SET_FIRST_DAY_OF_CURR_MONTH = "SET_FIRST_DAY_OF_CURR_MONTH",
  SET_PREV_MONTHS_DAYS = "SET_PREV_MONTHS_DAYS",
  SET_WEEKS_IN_MONTH = "SET_WEEKS_IN_MONTH",
  SET_PARSED_EVENT_LIST_AND_DAYS_OF_EVENTS = "SET_PARSED_EVENT_LIST_AND_DAYS_OF_EVENTS",
  SET_SHOW_FUTURE_EVENTS = 'SET_SHOW_FUTURE_EVENTS';

export const appendEvents = (events, occurrencesByEventId) => dispatch => {
  dispatch({
    type: APPEND_EVENTS,
    payload: {
      events: events,
      occurrencesByEventId: occurrencesByEventId,
    },
  });
};

export const getEvents = (monthKey) => {
  return (dispatch, getState) => {
    const state = getState().calendarEvents;
    if (!state.baseUrl) {
      console.warn('missing base url');
      return;
    }
    dispatch({
      type: GET_EVENT_LIST,
      payload: {},
    });
    const a = document.createElement('a');
    a.href = state.baseUrl;
    const url = new URL(a.href)
    url.searchParams.set('month', monthKey);
    qf.getJSON(url.toString()).then(data => {
      if (data.events && data.events.length > 0) {
        dispatch(appendEvents(data.events, data.occurrences_by_event_id));
      } else {
        dispatch({
          type: FAILED_EVENT_LIST,
          payload: {error: 'no events returned'}
        })
      }
    }).catch(err => {
      // what do
    });
  };
};

export const setCurrentDate = (currentDate, pageable, baseUrl) => dispatch => {
  dispatch({
    type: SET_CURRENT_DATE,
    payload: {
      currentDate: currentDate,
      pageable: !!pageable,
      baseUrl: baseUrl,
    },
  });
};

export const setEventList = (eventList, currDate) => dispatch => {
  dispatch({
    type: SET_EVENT_LIST,
    payload: {
      events: eventList,
      currentDate: currDate,
    }
  });
};

export const setParsedEventsAndDaysOfEvents = parsedEventsList => dispatch => {
  // console.log('parsedEventsList', parsedEventsList);
  dispatch({type: SET_PARSED_EVENT_LIST_AND_DAYS_OF_EVENTS, payload: parsedEventsList})
};

export const setMonthShown = (monthShown) => { 
  return (dispatch, getState) => {
    const state = getState().calendarEvents;
    const monthKey = `${String(monthShown.year).padStart(4, '0')}-${String(monthShown.month + 1).padStart(2, '0')}-01`;
    dispatch({type: SET_MONTH_SHOWN, payload: monthShown});
    if (!state.pageable || state.fetchedMonths[monthKey]) {
      return;
    }
    dispatch(getEvents(monthKey));
  };
};

export const setEventDate = eventDate => dispatch => {
  // console.log('setEventDate', eventDate);
  dispatch({type: SET_EVENT_DATE, payload: eventDate});
};

export const setShowFutureEvents = ()=>dispatch => {
  dispatch({type: SET_SHOW_FUTURE_EVENTS});
}